var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBillQuestionIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 43,
    viewBox: "0 0 49 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 42.1823L23.0985 38.1368L18.8065 41.0771L14.5113 38.1352L10.2161 41.0739L5.91278 38.132L0 42.1823V8.51009C0 7.22821 0.509225 5.99883 1.41565 5.09241C2.32208 4.18598 3.55145 3.67676 4.83333 3.67676L24.1667 3.67676C25.4485 3.67676 26.6779 4.18598 27.5844 5.09241C28.4908 5.99883 29 7.22821 29 8.51009V42.1823ZM5.91278 34.2266L10.2144 37.1685L14.5113 34.2266L18.8065 37.1685L23.1001 34.225L25.7778 36.0601V8.51009C25.7778 8.0828 25.608 7.67301 25.3059 7.37086C25.0038 7.06872 24.594 6.89898 24.1667 6.89898H4.83333C4.40604 6.89898 3.99625 7.06872 3.69411 7.37086C3.39196 7.67301 3.22222 8.0828 3.22222 8.51009V36.0601L5.91278 34.2266Z",
    fill: "#FFC535"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5556 16.5654H6.44446V19.7877H22.5556V16.5654Z",
    fill: "#FFC535"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 23.0098H6.44446V26.232H19.3333V23.0098Z",
    fill: "#FFC535"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1484 22.7191L32.6732 24.4926L36.9851 25.6479L37.3764 24.1875C37.5255 23.6311 37.6907 23.1536 37.923 22.8431C38.1553 22.5326 38.5198 22.1458 39.0328 21.7615L41.7764 19.5896C42.6166 18.9575 43.2736 18.3136 43.7382 17.6927C44.2027 17.0718 44.5561 16.3092 44.7797 15.4747C45.0965 14.2924 45.0979 13.1747 44.7931 12.0867C44.4883 10.9987 43.8841 10.0542 42.99 9.21829C42.0866 8.41717 40.9788 7.82219 39.6574 7.46812C37.5015 6.89044 35.674 7.03435 34.2283 7.83962C32.7385 8.67034 31.7001 10.1811 31.0877 12.3277L35.2953 13.4551C35.5375 12.551 35.9325 11.9114 36.4361 11.5619C36.9398 11.2123 37.6309 11.1366 38.4655 11.3602C39.3 11.5839 39.826 11.9857 40.1314 12.5148C40.4369 13.0438 40.4871 13.6909 40.2915 14.4211C40.161 14.908 39.9263 15.3668 39.6406 15.7375C39.3201 16.0989 38.8674 16.5367 38.257 17.0067L35.6829 18.9631C34.8427 19.5952 34.2831 20.1534 33.9695 20.6284C33.6465 21.1382 33.3907 21.815 33.1484 22.7191ZM31.9098 26.7851L30.7358 31.1665L35.2911 32.3871L36.4651 28.0057L31.9098 26.7851Z",
    fill: "#FFC535"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillQuestionIc);
export default __webpack_public_path__ + "static/media/bill_question_ic.871e18dc271f103fbb949bd444a65703.svg";
export { ForwardRef as ReactComponent };